import React from 'react'
import PropTypes from 'prop-types'

import {
  HotelPreviewBase,
  Row,
  RowHotelName,
  HotelName,
  HotelAddress,
  HotelRating,
  ImageBoxLeft,
  Image,
  ImageMap,
} from './styles'

import {
  getPropertyId,
  getPropertyName,
  getPropertyStars,
  getCitySlug,
  getCountry,
  getMapPreview,
  getFullAddress,
} from './utils'

import { LAYOUT_RESPONSIVE } from 'src/comps/Image/constants'
import Stars from 'client/components/Stars'
import { LinkToProperty } from './LinkToProperty'
import { LinkToPropertyMap } from './LinkToPropertyMap'
import { typeProperty } from 'client/types'
import { renderSrc } from 'src/helpers/imageHandler'

const HotelPreview = ({ hotelPreview, property }) => {
  if (!hotelPreview && !property?.photo && !hotelPreview?.propertyLocation) {
    return null
  }
  const photoURL = property?.photo ? renderSrc({ imgObj: property.photo, width: 580 }) : ''

  const propertyId = getPropertyId(hotelPreview, property)
  const propertyName = getPropertyName(hotelPreview, property)
  const propertyStars = getPropertyStars(hotelPreview, property)
  const fullAddress = getFullAddress(hotelPreview, property)
  const citySlug = getCitySlug(hotelPreview, property)
  const country = getCountry(hotelPreview, property)
  const mapPreview = getMapPreview(hotelPreview)

  return (
    <HotelPreviewBase>
      <Row className="noPrint">
        <ImageBoxLeft>
          <LinkToProperty propertyId={propertyId}>
            <Image
              src={photoURL}
              alt="hotel image"
              data-testid="hotel-image"
              width="100%"
              height={180}
              layout={LAYOUT_RESPONSIVE}
            />
          </LinkToProperty>
        </ImageBoxLeft>
        <ImageMap>
          <LinkToPropertyMap propertyId={propertyId} citySlug={citySlug} country={country}>
            <Image src={mapPreview} data-testid="hotel-map" />
          </LinkToPropertyMap>
        </ImageMap>
      </Row>
      <RowHotelName>
        <HotelName>
          <LinkToProperty propertyId={propertyId}>{propertyName}</LinkToProperty>
        </HotelName>
        {propertyStars ? (
          <LinkToProperty propertyId={propertyId}>
            <HotelRating>
              <Stars stars={propertyStars} size={15} color="grey2" />
            </HotelRating>
          </LinkToProperty>
        ) : null}
      </RowHotelName>
      <Row>
        <HotelAddress data-testid="hotel-address">
          <LinkToPropertyMap propertyId={propertyId} citySlug={citySlug} country={country}>
            {fullAddress}
          </LinkToPropertyMap>
        </HotelAddress>
      </Row>
    </HotelPreviewBase>
  )
}

HotelPreview.propTypes = {
  hotelPreview: PropTypes.shape({
    propertyId: PropTypes.string,
    propertyCity: PropTypes.string,
    propertyCountry: PropTypes.string,
    propertySlug: PropTypes.string,
    fullAddress: PropTypes.string,
    addressUrl: PropTypes.string,
    propertyAddress: PropTypes.string.isRequired,
    propertyName: PropTypes.string.isRequired,
    propertyStars: PropTypes.number,
    propertyImages: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string,
        source: PropTypes.string,
        code: PropTypes.string,
        bookingIdRoom: PropTypes.string,
      })
    ),
    propertyLocation: PropTypes.shape({
      cityName: PropTypes.string,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      postalCode: PropTypes.string,
    }),
  }),
  property: typeProperty,
}

export default HotelPreview
